// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#xterm-wrapper {
    height: calc(100vh - 120px);
}

.xterm-viewport {
    overflow-y: hidden !important;
}

.xterm-rows {
    filter: blur(1px);
}
`, "",{"version":3,"sources":["webpack://./src/styles/xterm.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":["#xterm-wrapper {\n    height: calc(100vh - 120px);\n}\n\n.xterm-viewport {\n    overflow-y: hidden !important;\n}\n\n.xterm-rows {\n    filter: blur(1px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
